module.exports = __webpack_public_path__ + "static/media/94.7f7f8e60.jpg";